import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";

export default function HalvedImageSection({
  image,
  imagePosition = "left",
  content,
  reverseMobile = false,
  ...props
}) {
  const isImageLeft = imagePosition === "left";

  const ImageBox = (
    <Box
      sx={{
        flex: 1,
        backgroundImage: `url(${image})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        borderRadius: 1,
        aspectRatio: { xs: undefined, lg: 1 },
        minHeight: { xs: '200px', lg: undefined },
        width: "100%",
      }}
    />
  );

  return (
    <Box
      alignItems="center"
      display="flex"
      gap={{ xs: 3, lg: 6 }}
      flexDirection={{ xs: reverseMobile ? "column-reverse" : "column", lg: "row" }}
      {...props}
    >
      {isImageLeft && ImageBox}
      <Box sx={{ flex: 1, flexShrink: 0 }}>{content}</Box>
      {!isImageLeft && ImageBox}
    </Box>
  );
}

HalvedImageSection.propTypes = {
  image: PropTypes.string.isRequired,
  imagePosition: PropTypes.oneOf(["left", "right"]),
  content: PropTypes.node.isRequired,
    reverseMobile: PropTypes.bool,
};
